import { render, staticRenderFns } from "./ShippingServiceSurchargesComponent.vue?vue&type=template&id=6a926518&"
import script from "./ShippingServiceSurchargesComponent.vue?vue&type=script&lang=js&"
export * from "./ShippingServiceSurchargesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports